export default __webpack_public_path__ + "static/media/logo-myflexdollars.751617bc.png";